/**
 * Service layer — Role Profiles.
 *
 * Owns the role_profiles table (Supabase) behind the Clerk-authed /api/role-profiles endpoint.
 * Components never call the API directly — they go through here. See docs/ROLE_PROFILES.md.
 */

/**
 * Get a Clerk token, waiting briefly for the getter to exist — mirrors services/studioCalendar.js.
 */
async function token() {
  for (let i = 0; i < 25; i++) {
    if (typeof window !== 'undefined' && typeof window.__clerkGetToken === 'function') {
      try { const t = await window.__clerkGetToken(); if (t) return t } catch { /* retry */ }
    }
    await new Promise(r => setTimeout(r, 150))
  }
  return null
}

async function post(payload) {
  const headers = { 'Content-Type': 'application/json' }
  const t = await token(); if (t) headers['Authorization'] = 'Bearer ' + t
  const res = await fetch('/api/role-profiles', { method: 'POST', headers, body: JSON.stringify(payload) })
  const data = await res.json().catch(() => ({ error: 'Bad response from /api/role-profiles' }))
  if (!res.ok || data.error) throw new Error(data.error || ('Request failed (' + res.status + ')'))
  return data
}

export async function listRoleProfiles() {
  return (await post({ action: 'list' })).roles || []
}

export async function updateRoleProfile(roleKey, fields) {
  return (await post({ action: 'update', roleKey, ...fields })).role
}

/** Replace who holds a role (database/278). holders: [{ memberId, name }] — Airtable Member ids. */
export async function setRoleHolders(roleKey, holders) {
  return (await post({ action: 'setHolders', roleKey, holders })).role
}
